<template>
  <div>
    <div class="row">
      <div class="col-lg-5 ">
        <b-form-group>
          <b-input-group size="md">
            <b-form-input
              v-model="pagination.filter"
              :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
              type="search"
              id="filterInput"
              debounce="500"
              @update="searchFilter()"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="!pagination.filter"
                @click="
                  pagination.filter = '';
                  searchFilter();
                "
                >{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-lg-7 ">
        <b-button
          class="float-right"
          variant="primary"
          @click="downloadData()"
          :disabled="items.length == 0"
        >
          <b-icon icon="file-earmark-text"></b-icon>
          {{
            $t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.DOWNLOADEXCEL"
            )
          }}
        </b-button>
      </div>

      <div class="col-lg-12 pb-5">
        <div class="row">
          <div class="col-lg-3 col-xxl-3">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="" align-self="center">
                  {{
                    $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.FROM")
                  }}
                </label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <date-picker v-model="from" :config="options"></date-picker>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xxl-3">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="">{{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.TO")
                }}</label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <date-picker v-model="to" :config="options"></date-picker>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xxl-3">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="">{{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.STATUS")
                }}</label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <b-form-select
                  v-model="filter_is_approve"
                  id="is-approve-filter"
                  :options="filter_approval_list"
                ></b-form-select>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xxl-3 pt-5">
            <b-button
              block
              class="float-right"
              type="submit"
              variant="primary"
              @click.prevent="searchFilter()"
            >
              {{
                $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.SEARCH")
              }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-content">
      <div class="table-responsive">
        <b-table
          id="organizations-table"
          :striped="false"
          :small="true"
          :items="items"
          :fields="fields"
          :sort-by.sync="pagination.orderBy"
          :sort-desc.sync="pagination.isDesc"
          :no-sort-reset="true"
          :no-local-sorting="true"
          :busy.sync="isBusy"
          :loading="false"
          :borderless="false"
          head-variant="light"
          @sort-changed="sortChange"
        >
          <template #cell(id)="data">
            <div class="text-right">
              <span v-if="pagination.isDesc">{{
                total -
                  (pagination.perPage * (pagination.page - 1) + data.index)
              }}</span>
              <span v-if="!pagination.isDesc">
                {{
                  pagination.perPage * (pagination.page - 1) + data.index + 1
                }}
              </span>
            </div>
          </template>

          <template #cell(customer_campaign_receipt.is_approve)="data">
            <span v-if="data.item.is_approve == 0" class="text-warning">{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
            }}</span>
            <span v-else-if="data.item.is_approve == 1" class="text-success">{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
            }}</span>
            <span v-else>{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
            }}</span>
          </template>

          <template #cell(customer_campaign_receipt.point)="data">
            <div class="text-right">
              <span v-if="data.item.point">{{ data.item.point }}</span>
              <span v-else>-</span>
            </div>
          </template>

          <template #cell(customer_campaign_receipt.verify_code)="data">
            <span v-if="data.item.verify_code">{{
              data.item.verify_code
            }}</span>
            <span v-else>-</span>
          </template>

          <template #cell(customer_campaign_receipt.remark)="data">
            <span v-if="data.item.remark">{{ data.item.remark }}</span>
            <span v-else>-</span>
          </template>

          <template #cell(action)="data">
            <a
              href="javascript:"
              @click.prevent="openFormModal(data.item.id)"
              class="btn btn-icon btn-light btn-sm"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <inline-svg
                  src=" media/svg/icons/General/Edit.svg"
                ></inline-svg>
              </span>
            </a>
          </template>
        </b-table>

        <p class="text-center pt-3" v-if="items.length < 1">
          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
        </p>
      </div>

      <div class="row justify-content-between">
        <div div class="col-lg-3">
          <b-form-group
            id="name-input-group"
            :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
            label-for="name-input"
            label-cols="5"
            label-align-sm="left"
            label-size="lg"
          >
            <b-form-select
              v-model="pagination.perPage"
              id="perPageSelect"
              size="sm"
              :options="paginationOptions"
              @change="fetchData()"
            ></b-form-select>
          </b-form-group>
        </div>

        <div div class="col-lg-6">
          <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.perPage"
            @input="fetchData()"
            align="right"
          ></b-pagination>
        </div>
      </div>
    </div>

    <div class="form-modal">
      <b-modal
        size="xl"
        id="modal-form"
        ref="modal"
        :title="this.$t('PAGE.CAMPAIGN.FORM.MODAL.CUSTOMER_RECEIPT')"
        :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
        :ok-disabled="is_checking_verify_code"
        :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
        @ok="handleSubmit"
      >
        <form ref="form" @submit.stop.prevent="handleSave">
          <b-row class="mb-1 text-center">
            <b-col class="col-image">
              <b-row id="ccr-recepit-image" class="mb-5">
                <b-col sm="12 text-center">
                  <a :href="form.receipt_image" target="_blank">
                    <img
                      :src="form.receipt_image"
                      class="receipt-image"
                      alt="Receipt image"
                    />
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-form">
              <b-row id="ccr-customer" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.CUSTOMER"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="customer-input"
                    name="customer-input"
                    v-model="form.customer_fullname"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row
                id="ccr-receipt-type"
                v-if="is_redeem_reward == 0"
                class="mb-5"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REWARD")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="receipt-type-input"
                    name="receipt-type-input"
                    v-model="form.reward_name"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row id="ccr-receipt-type" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_TYPE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-select
                    v-model="form.receipt_type_id"
                    id="receipt-type-input"
                    :options="receipt_type_list"
                  ></b-form-select>
                </b-col>
              </b-row>

              <b-row id="ccr-is-approve" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.IS_APPROVE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-select
                    v-model="form.is_approve"
                    id="is-approve-input"
                    :options="approval_list"
                    @change="checkNotApprove($event)"
                    :disabled="is_approve"
                  ></b-form-select>
                </b-col>
              </b-row>

              <b-row
                id="ccr-unapproved_reason"
                class="mb-5 text-left"
                v-if="is_select_not_approve"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REASON_NOT_APPROVE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.unapproved_reason_id"
                      :options="option_radio"
                      name="radios-stacked"
                      @change="checkOtherReason($event)"
                      stacked
                      :disabled="is_approve"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row
                id="ccr-unapproved_reason_remark"
                class="mb-5"
                v-if="is_select_not_approve && is_select_reason_other"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.UNAPPROVED_REASON_REMARK"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-textarea
                    id="remark-input"
                    name="remark-input"
                    v-model="form.unapproved_reason_remark"
                    rows="3"
                    max-rows="6"
                    :disabled="is_approve"
                  ></b-form-textarea>
                </b-col>
              </b-row>

              <b-row id="ccr-point" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.POINT")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    type="number"
                    @wheel="$event.target.blur()"
                    @keypress="isNumber($event)"
                    id="point-input"
                    name="point-input"
                    v-model="$v.form.point.$model"
                    :state="validateState('point')"
                    aria-describedby="name-live-feedback"
                  ></b-form-input>

                  <b-form-invalid-feedback id="name-live-feedback">
                    <span v-if="!$v.form.point.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row id="ccr-verify-code" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.VERIFY_CODE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="verify-code-input"
                    name="verify-code-input"
                    @keyup="handleVerifyCodeExist($event)"
                    v-model="form.verify_code"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row id="ccr-remark" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REMARK")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-textarea
                    id="remark-input"
                    name="remark-input"
                    v-model="form.remark"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-col>
              </b-row>

              <div
                v-if="form.duplicate_receipt.length"
                class="duplicate-receipt-container"
              >
                <div class="duplicate-receipt-wrapper">
                  <h2 class="title">
                    พบรายการใบเสร็จซ้ำ
                  </h2>

                  <b-row>
                    <b-col
                      v-for="duplicate in form.duplicate_receipt"
                      :key="duplicate.id"
                      sm="3"
                    >
                      <a :href="duplicate.receipt_image" target="_blank">
                        <img
                          :src="duplicate.receipt_image"
                          alt="duplicate_receipt_image"
                          class="duplicate-receipt-image"
                        />
                      </a>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {
  PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT,
  FIND_CUSTOMER_CAMPAIGN_RECEIPT,
  UPDATE_CUSTOMER_CAMPAIGN_RECEIPT,
  SET_PAGINATION,
  SET_IS_CLEAR_PAGINATION,
  CLEAR_PAGINATION,
  CHECK_RECEIPT_CODE_EXIST
} from "@/core/services/store/customer_campaign_receipt.module";
import { GET_UNAPPROCED_REASON } from "@/core/services/store/unapproced_reason.module";
import { GET_RECEIPT_TYPE } from "@/core/services/store/receipt_type.module";
import { en, th } from "vuejs-datepicker/dist/locale";
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  name: "CustomerCampaignReceipt",
  mixins: [validationMixin],
  props: ["campaign_id", "is_redeem_reward"],
  components: {
    datePicker
  },
  data() {
    return {
      from: null,
      to: null,
      filter_is_approve: 99,
      is_select_not_approve: false,
      is_approve: false,
      is_checking_verify_code: false,
      is_select_reason_other: false,
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      option_radio: [],
      fields: [
        {
          key: "id",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          key_table: "customer_campaign_receipt.id",
          sortable: false,
          isFilter: false,
          tdClass: "idField"
        },
        {
          key: "created_at",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.CREATED_AT")}`,
          key_table: "customer_campaign_receipt.created_at",
          sortable: true,
          isFilter: false
        },
        {
          key: "customer_fullname",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.CUSTOMER")}`,
          key_table: "customer_fullname",
          sortable: false,
          isFilter: true
        },
        {
          key: "receipt_type_name",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.RECEIPT_TYPE")}`,
          key_table: "receipt_type_name",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.is_approve",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.TITLE")}`,
          key_table: "customer_campaign_receipt.is_approve",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.point",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.POINT")}`,
          thClass: "text-right",
          key_table: "customer_campaign_receipt.point",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.verify_code",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.VERIFY_CODE")}`,
          key_table: "customer_campaign_receipt.verify_code",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.remark",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.REMARK")}`,
          key_table: "customer_campaign_receipt.remark",
          sortable: true,
          isFilter: true
        },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField"
        }
      ],
      select: [
        "customer_campaign_receipt.id",
        "customer.first_name",
        "customer.last_name",
        "receipt_type.name as receipt_type_name",
        "customer_campaign_receipt.point",
        "customer_campaign_receipt.verify_code",
        "customer_campaign_receipt.remark",
        "customer_campaign_receipt.is_approve",
        "customer_campaign_receipt.created_at",
        "customer_campaign_receipt.status_id"
      ],
      include: [],
      paginationOptions: [25, 50, 100, 200],
      isBusy: false,
      items: [],
      total: 0,
      form: {
        receipt_type_id: null,
        is_approve: 0,
        unapproved_reason_id: null,
        unapproved_reason_remark: null,
        point: null,
        verify_code: null,
        remark: null,
        duplicate_receipt: []
      },
      approval_list: [
        {
          value: 0,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
        },
        {
          value: 1,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
        },
        {
          value: 2,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
        }
      ],
      filter_approval_list: [
        {
          value: 99,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.ALL")
        },
        {
          value: 0,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
        },
        {
          value: 1,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
        },
        {
          value: 2,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
        }
      ],
      receipt_type_list: []
    };
  },
  validations: {
    form: {
      point: {
        required
      }
    }
  },
  computed: {
    isClearPagination: {
      get() {
        return this.$store.state.customer_campaign_receipt.isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value
        });
      }
    },
    pagination: {
      get() {
        return this.$store.state.customer_campaign_receipt.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      }
    }
  },
  mounted() {
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }

    this.isClearPagination = true;
    this.getReceiptType();
    this.fetchData();
  },
  methods: {
    isNumber(event) {
      if (
        !(
          event.key === "Enter" ||
          (Number(event.key) >= 0 && Number(event.key) <= 9)
        )
      ) {
        return event.preventDefault();
      }
    },
    getParams() {
      const orderByIndex = this.fields.findIndex(
        item => item.key === this.pagination.orderBy.toString()
      );
      return {
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        orderBy: orderByIndex
          ? this.fields[orderByIndex].key_table
          : "created_at",
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        from: this.from,
        to: this.to,
        is_approve: this.filter_is_approve,
        filterBy: `${this.fields
          .map(item => {
            if (item.isFilter) return item.key;
          })
          .filter(item => !!item)}`,
        select: `${this.select}`,
        include: `${this.include}`,
        campaign_id: this.campaign_id
      };
    },
    getUnapprocedReason() {
      this.$store
        .dispatch(GET_UNAPPROCED_REASON)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.option_radio = data.data.map(data => {
              data.value = data.id;
              data.text = data.name;
              return data;
            });
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    getReceiptType() {
      this.$store
        .dispatch(GET_RECEIPT_TYPE)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            for (const receipt of data.data) {
              this.receipt_type_list.push({
                text: receipt.name,
                value: receipt.id
              });
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchData();
    },
    searchFilter() {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.fetchData();
          Swal.close();
        }
      });
    },
    checkNotApprove(event) {
      this.is_select_not_approve = event === 2;
      if (event === 2) {
        this.$v.form.point.$model = 0;
        this.getUnapprocedReason();
      }
    },
    checkOtherReason(event) {
      this.is_select_reason_other = event === 99;
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT, {
          params: this.getParams()
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    downloadData() {
      let params = this.getParams();
      let params_open = "";
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          if (key !== "page") {
            params_open += "&";
          }
          params_open += `${key}=${params[key]}`;
        }
      }
      window.open(
        `${Vue.axios.defaults.baseURL}/customer_campaign_receipt_excel?${params_open}`,
        "_system"
      );
    },
    openFormModal(id) {
      this.$store
        .dispatch(FIND_CUSTOMER_CAMPAIGN_RECEIPT, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form = data.data;
            this.form.customer_fullname = `${data.data.first_name} ${data.data.last_name}`;
            this.form.receipt_image = `${data.data.receipt_image}`;
            this.form.campaign_id = this.campaign_id;
            this.is_approve = data.data.is_approve === 1;
            this.checkNotApprove(data.data.is_approve);
            this.checkOtherReason(data.data.unapproved_reason_id);
            this.$bvModal.show("modal-form");
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    handleSubmit(bvModalEvt) {
      if (this.form.duplicate_receipt.length) {
        Swal.fire({
          text: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFIRM_SUBMIT_WITH_DUPLICATE"
          )}`,
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
          cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
        }).then(result => {
          if (result.isConfirmed) {
            bvModalEvt.preventDefault();
            this.$v.form.$touch();

            if (this.$v.form.$anyError) {
              return;
            }

            this.handleSave(this.form, this.form.id);
          }
        });
      } else {
        bvModalEvt.preventDefault();
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        this.handleSave(this.form, this.form.id);
      }
    },
    handleSave(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CUSTOMER_CAMPAIGN_RECEIPT, { id, data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  html: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")} <br/>
                  ${
                    data.data === "LINE_TOKEN_AUTHENTICATION_FAILED"
                      ? this.$t(
                          "RESPONSE_MESSAGE.SAVE_DATA_SUCCESS_LINE_TOKEN_AUTH_FAILE"
                        )
                      : ""
                  }
                  `
                });
                this.$v.$reset();
                this.fetchData();
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-form");
                });
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: this.$t("RESPONSE_MESSAGE." + data.error),
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: error,
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            });
        }
      });
    },
    getLanguage() {
      switch (this.$i18n.locale) {
        case "th":
          return th;
        case "en":
          return en;
        default:
          return th;
      }
    },
    handleVerifyCodeExist(event) {
      let verifyCode = event.target.value;
      this.is_checking_verify_code = true;
      this.checkVerifyCodeExist(verifyCode);
    },
    checkVerifyCodeExist: _.debounce(function(verifyCode) {
      this.$store
        .dispatch(CHECK_RECEIPT_CODE_EXIST, {
          verify_code: verifyCode,
          campaign_id: this.campaign_id,
          id: this.form.id
        })
        .then(({ data }) => {
          this.form.duplicate_receipt = data.data;
          this.is_checking_verify_code = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    }, 300)
  }
};
</script>

<style scoped lang="scss">
.receipt-image {
  width: 100%;
  margin-bottom: 15px;
  border: solid 2px #ddd;
  border-radius: 5px;
  cursor: pointer;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-center label {
  margin: 0;
}

.duplicate-receipt-container {
  margin-top: 30px;
  border-top: solid 1px #ccc;

  .duplicate-receipt-wrapper {
    border: solid 1px #ff0000;
    padding: 15px;
    margin-top: 15px;
    background: #f3f6f9;
    border-radius: 5px;

    .title {
      text-align: left;
      color: #ff0000;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      padding-bottom: 15px;
    }

    .duplicate-receipt-image {
      width: 100%;
    }
  }
}
</style>
